import {createContext, useReducer} from 'react'

// creating context
export const QuotesContext = createContext()

// reducer function
export const quotesReducer = (state, action) => {

    // switching through action
    switch(action.type){
        // this will set the current clients as the current state
        case "SET_QUOTES":
            return {
                quotes: action.payload
            }
        // This will set the current client state as the current client state + the new client we pass in     
        case "CREATE_QUOTE":
            if(state.quotes == null){
                return [action.payload]
            }
            else{
                return{
                    quotes: [action.payload, ...state.quotes]
                }
            }
            
        // This will filter through the current state of clients, and return all of them except the one we pass in (the one we are deleting)     
        case "DELETE_QUOTE":
            return{
                quotes: state.quotes.filter((quote) => quote._id !== action.payload._id)
            }
        // otherwise we just return the state     
        default:
            return state            
    }
}

// this provides the context
export const QuotesContextProvider = ({children}) => {

    // this is our state + reducer function, which we will pass down as a value to our children below 
    const [state, dispatch] = useReducer(quotesReducer, {
        quotes: null
    })

    return (

        <QuotesContext.Provider value={{...state,dispatch}}>
            {children}
        </QuotesContext.Provider>
    )
}

